import React, { Suspense, useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';

//general
import PrivateRoute from './components/PrivateRoute';
import loadingAnimation from './lotties/loading.json';
import Lottie from 'react-lottie';
const Reports = React.lazy(() => import('./screens/specific/Reports'));
const Dashboard = React.lazy(() => import('./screens/mainPages/Dashboard'));
const PulseElement = React.lazy(() => import('./screens/mainPages/PulseElement'));

const InsightsRoutes = () => {
  const [isAnimationPlaying, setIsAnimationPlaying] = useState(true);

  useEffect(() => {
    return () => {
      setIsAnimationPlaying(false);
    };
  }, []);

  return (
    <Suspense fallback={
      <div>
        <div className="loader">
          Loading...
        </div>
      </div>
    }>
      <Routes>
        <Route
          path="/"
          element={
            <PrivateRoute
              permission={['ADMIN', 'MANAGER', 'STANDARD', 'OWNER', 'PERSONAL']}
            >
              <Reports />
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute
              permission={['ADMIN', 'MANAGER', 'STANDARD', 'OWNER', 'PERSONAL']}
            >
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/:structureId/:boardId"
          element={
            <PrivateRoute
              permission={['ADMIN', 'MANAGER', 'STANDARD', 'OWNER', 'PERSONAL']}
            >
              <PulseElement />
            </PrivateRoute>
          }
        />
      </Routes>
    </Suspense>
  );
};

export default InsightsRoutes;
